export const BERBUS_PLACE_VENDOR_GMAPS = 'gmaps';
export const BERBUS_PLACE_VENDOR_LOCAL = 'local';

export const BERBUS_PLACE_VENDORS = [
    BERBUS_PLACE_VENDOR_GMAPS,
    BERBUS_PLACE_VENDOR_LOCAL,
];

export const PASSENGER_TYPE_ADULT = 'adult';
export const PASSENGER_TYPE_CHILD = 'child';
export const PASSENGER_TYPE_CHILD_AGE_3 = 'child_age_3';

export const PAYMENT_STATUS_PENDING = 'pending';
export const PAYMENT_STATUS_PAID = 'paid';
export const PAYMENT_STATUS_REJECTED = 'rejected';
export const PAYMENT_STATUS_ERROR = 'error';

export const AT_BERLIN_BRANDENBURG_CODE = 1010539;

/**
 * Delay that log wait message displays, change to false to disable
 * Default: 6000
 * Unit: ms
 */
export const AIRPORT_TRANSFERS_LONG_WAIT_MESSAGE_TIMEOUT = false;
